import { Commands } from '.';
var PrintAction = (function () {
    function PrintAction(dialogResult, button, path, filename, extension, controller, action) {
        if (filename === void 0) { filename = null; }
        if (extension === void 0) { extension = null; }
        if (controller === void 0) { controller = 'ResumeOperation'; }
        if (action === void 0) { action = 'ResumePendingOperationWithArgs'; }
        this.myDialogResult = dialogResult;
        this.myPath = path;
        this.myButton = button;
        this.myAction = action;
        this.myExtension = extension;
        this.myController = controller;
        this.myFileName = filename;
    }
    Object.defineProperty(PrintAction.prototype, "name", {
        get: function () {
            return Commands.PrintActionCommand;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrintAction.prototype, "dialogResult", {
        get: function () {
            return this.myDialogResult;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrintAction.prototype, "controller", {
        get: function () {
            return this.myController;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrintAction.prototype, "action", {
        get: function () {
            return this.myAction;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrintAction.prototype, "args", {
        get: function () {
            var args = [];
            if (this.myPath || this.myPath === '') {
                args.push(this.myPath);
            }
            if (this.myFileName || this.myFileName === '') {
                args.push(this.myFileName);
            }
            if (this.myExtension) {
                args.push(this.myExtension);
            }
            return { buttons: this.myButton, args: args };
        },
        enumerable: false,
        configurable: true
    });
    return PrintAction;
}());
export { PrintAction };
